import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Button,
  Text,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  useToast
} from "@chakra-ui/react";
import DataTable from "./AppDataTable";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faEye,
  faSearch,
  faTable,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { tableCustomStyles } from "../themes/TableStyles";

const QuestionnaireList = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [questionnaires, setQuestionnaires] = useState([]);
  const [filteredQuestionnaires, setFilteredQuestionnaires] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    // Load questionnaires from local storage
    try {
      const stored = JSON.parse(localStorage.getItem("questionnaires") || "[]");
      setQuestionnaires(stored);
      setFilteredQuestionnaires(stored);
    } catch (error) {
      console.error("Error loading questionnaires:", error);
    }
  }, []);

  useEffect(() => {
    // Filter questionnaires based on title
    const filtered = questionnaires.filter((q) =>
      q.title.toLowerCase().includes(filterText.toLowerCase())
    );
    setFilteredQuestionnaires(filtered);
  }, [filterText, questionnaires]);

  const handleCopyLink = (id) => {
    const link = `${window.location.origin}/questionnaire-form/${id}`;
    navigator.clipboard.writeText(link).then(
      () => {
        toast({
          title: "คัดลอกลิงก์สำเร็จ",
          description: "ลิงก์สำหรับกรอกแบบสอบถามถูกคัดลอกไปยังคลิปบอร์ดแล้ว",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      },
      (err) => {
        console.error("Error copying link:", err);
        toast({
          title: "เกิดข้อผิดพลาด",
          description: "ไม่สามารถคัดลอกลิงก์ได้ กรุณาลองอีกครั้ง",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    );
  };

  const columns = [
    {
      name: "ชื่อแบบสอบถาม",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "จำนวนฟิลด์",
      selector: (row) => row.fields.length,
      sortable: true,
      width: "150px",
    },
    {
      name: "การดำเนินการ",
      cell: (row) => (
        <HStack spacing={2}>
          <Button
            leftIcon={<FontAwesomeIcon icon={faEdit} />}
            colorScheme="iBlue"
            size="sm"
            width="120px"
            onClick={() => navigate(`/questionnaire-form/${row.id}`)}
          >
            กรอกแบบสอบถาม
          </Button>
          <Button
            leftIcon={<FontAwesomeIcon icon={faEye} />}
            colorScheme="gray"
            size="sm"
            width="120px"
            onClick={() => navigate(`/response-list/${row.id}`)}
          >
            ดูผลลัพธ์
          </Button>
          <Button
            leftIcon={<FontAwesomeIcon icon={faLink} />}
            colorScheme="iPurple"
            size="sm"
            width="120px"
            onClick={() => handleCopyLink(row.id)}
          >
            สำเนาลิงก์
          </Button>
        </HStack>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "450px",
    },
  ];

  return (
    <Box p={35} m={25} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <Box
        mb={5}
        borderRadius="full"
        w="100%"
        bgColor="iPink.500"
        color="white"
        p={2}
      >
        <HStack spacing={5} ml={5}>
          <FontAwesomeIcon icon={faTable} color="white" size="xl" />
          <Heading size="lg" fontWeight="normal">
            รายการแบบสอบถาม
          </Heading>
        </HStack>
      </Box>
      <Box m={10} textAlign="center">
        <HStack justify="space-between" mb={6}>
          <Text>ทั้งหมด {filteredQuestionnaires.length} แบบสอบถาม</Text>
          <Button
            leftIcon={<FontAwesomeIcon icon={faPlus} />}
            colorScheme="iBlue"
            onClick={() => navigate("/questionnaire-builder")}
          >
            สร้างแบบสอบถามใหม่
          </Button>
        </HStack>
        <InputGroup mb={6}>
          <InputLeftElement pointerEvents="none">
            <FontAwesomeIcon icon={faSearch} color="gray.300" />
          </InputLeftElement>
          <Input
            placeholder="ค้นหาแบบสอบถามโดยชื่อ"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            colorScheme="iBlue"
          />
        </InputGroup>
        <DataTable
          columns={columns}
          data={filteredQuestionnaires}
          highlightOnHover
          striped
          responsive
          customStyles={tableCustomStyles}
          noDataComponent={
            <Text textAlign="center" p={5}>
              ยังไม่มีแบบสอบถาม
            </Text>
          }
        />
      </Box>
    </Box>
  );
};

export default QuestionnaireList;
